import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentsTable} from 'src/app/item-tracker/ItemAssignmentsTable';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const ItemAssignmentListPage: React.FC = () => {
  useSetDocumentTitle(itemAssignmentDocumentTitle);
  const {definitionId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {definitionId === undefined ? (
        <>Invalid URL parameters</>
      ) : (
        <ItemAssignmentsTable
          itemDefinitionId={definitionId}
          itemDefinitionLabel="item"
        />
      )}
    </ContentWrapper>
  );
};

export default ItemAssignmentListPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemAssignments(':definitionId'),
  element: <ItemAssignmentListPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerAssignments,
  operation: PermissionOperationEnum.View,
});
